module.exports = __webpack_public_path__ + "media/assets/faria_products/Cambridge IGCSE's-0bbf42b3d079d8d40640a77ed597755675ecc01a855bbad0f0ec7582e4848f6f.png";